import { Json } from 'shared-base/dist/types';
import { toast } from '../../../Toast/Toast.actions';
import { Data, DataPreview, Message, Timestamp, Wrapper } from './Log.style';
import { parseTimestamp } from './Log.utils';

export type LogProps = {
  log: Json;
};

export function Log(props: LogProps) {
  const { log } = props;
  const { message, timestamp, data } = log;

  function onDataClick() {
    console.log(data);
  }

  function onClick() {
    navigator.clipboard.writeText(JSON.stringify(data, null, 4));
    toast.show('Copied to clipboard');
  }

  function renderDataPreview() {
    if (!data) return null;

    const text = JSON.stringify(data);

    return (
      <DataPreview onClick={onClick} title={text}>
        {text}
      </DataPreview>
    );
  }

  function renderMessage() {
    const [scope, body] = message.split('|');

    return (
      <Message title={body}>
        <span>{scope}</span>| {body}
        {renderDataPreview()}
      </Message>
    );
  }

  return (
    <Wrapper className='Log-wrapper' data-testid='Log-wrapper'>
      <Timestamp>{parseTimestamp(timestamp)}</Timestamp>
      <Message>{renderMessage()}</Message>
      {data && <Data onClick={onDataClick}>data</Data>}
    </Wrapper>
  );
}

export default Log;
